// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"4b4727ff","456":"c9215111","569":"8e88f06e","638":"28a7b0e9","852":"2fb09a3a"}[chunkId] + ".chunk.js";
};